import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

export const GoogleLoginFunction = (callBackFunction) => {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Fetch user info
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }
        );

        // Create a user object with relevant data
        const userData = {
          email: userInfo.data.email,
          name: userInfo.data.name,
          picture: userInfo.data.picture,
          accessToken: tokenResponse.access_token,
          code: tokenResponse.code, // For server-side exchange
        };

        // If you need refresh tokens, send the auth code to your backend
        if (tokenResponse.code) {
          // You would implement this function to call your backend
          // await exchangeCodeForRefreshToken(tokenResponse.code);
        }

        // Call the callback with user data
        callBackFunction(userData, null);
      } catch (error) {
        console.error("Error processing Google login:", error);
        callBackFunction(null, error);
      }
    },
    onError: (error) => {
      console.error("Login Failed:", error);
      callBackFunction(null, error);
    },
    // Scopes for Gmail access and offline access (for refresh tokens)
    scope:
      "https://mail.google.com/ https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
    flow: "implicit", // Use auth-code flow for refresh tokens
  });

  // Return the login function instead of immediately invoking it
  return login;
};
